/* CDN cache-bust 2026-05-21: forcing edge refresh after WABA fix */
(function () {
  const IDS = {
    widget: "custom-chat-widget",
    closeBtn: "chat-close-btn",
    toggleBtn: "chat-toggle-btn",
    chatBox: "chat-box",
    minimizedIcon: "minimized-widget-icon",
    salesBtn: "chatWa",
    languageSwitch: "language-switch",
  };
  const STORAGE_KEYS = {
    minimized: "euChatWidgetMinimized",
    mobileOpen: "euChatWidgetMobileOpen",
    language: "euChatWidgetLang",            // legacy — kept for fallback compatibility
    languageOverride: "euChatWidgetLangOverride", // ONLY set when user explicitly chooses from dropdown
  };
  const waTranslations = {
  "en": {
    "greeting": "Hi, I'm Jordan 👋",
    "hookHeader": "Have any questions? I'm here to help!",
    "bookDemo": "📞 Book a Demo With Me",
    "chatWa": "💬 Chat on WhatsApp",
    "support": "🛟 Get Support",
    "role": "Product Specialist",
    "chatWith": "Chat With Jordan",
    "image": "https://storage.googleapis.com/msgsndr/gs8BnQHT0c6ZesS8QkWf/media/689c9db41f951e79f66a960c.jpeg",
    "bookDemoUrl": "https://speediance.eu/pages/demo-speediance",
    "supportUrl": "https://speediance.eu/pages/contact"
  },
  "de": {
    "greeting": "Hallo, ich bin Marco 👋",
    "hookHeader": "Hast du Fragen? Ich bin hier, um zu helfen!",
    "bookDemo": "📞 Demo mit mir buchen",
    "chatWa": "💬 Chat auf WhatsApp",
    "support": "🛟 Support erhalten",
    "role": "Produktspezialist",
    "chatWith": "Chatte mit Marco",
    "image": "https://storage.googleapis.com/msgsndr/qO7EpNj95iLIcx6VzjRK/media/6834c222016c699e4af78224.jpeg",
    "bookDemoUrl": "https://speediance.eu/pages/demo-speediance",
    "supportUrl": "https://speediance.eu/pages/contact"
  },
  "fr": {
    "greeting": "Bonjour, je suis Melissa 👋",
    "hookHeader": "Vous avez des questions ? Je suis là pour vous aider !",
    "bookDemo": "📞 Réserver une démo avec moi",
    "chatWa": "💬 Discuter sur WhatsApp",
    "support": "🛟 Obtenir de l'aide",
    "role": "Spécialiste Produit",
    "chatWith": "Discuter avec Melissa",
    "image": "https://ca.slack-edge.com/T07RVMBGA2V-U0ALF3NG2R3-b86b134adc5f-512",
    "bookDemoUrl": "https://cal.futuremvmt.com/melissa/full-demo",
    "supportUrl": "https://speediance.eu/pages/contact"
  },
  "nl": {
    "greeting": "Hallo, ik ben Jordan 👋",
    "hookHeader": "Heb je vragen? Ik ben er om te helpen!",
    "bookDemo": "📞 Boek een demo met mij",
    "chatWa": "💬 Chat op WhatsApp",
    "support": "🛟 Hulp krijgen",
    "role": "Productspecialist",
    "chatWith": "Chat met Jordan",
    "image": "https://storage.googleapis.com/msgsndr/gs8BnQHT0c6ZesS8QkWf/media/689c9db41f951e79f66a960c.jpeg",
    "bookDemoUrl": "https://speediance.eu/pages/demo-speediance",
    "supportUrl": "https://speediance.eu/pages/contact"
  }
};
  // Page-aware hook copy. If a (pageType, lang) combo is present, it overrides
  // the default hookHeader from waTranslations. Add new page types as needed.
  const pageHooks = {
    home: {
      en: "Want a personal recommendation? I\u2019ll find the right model for you.",
      de: "M\u00f6chtest du eine pers\u00f6nliche Empfehlung? Ich finde das passende Modell f\u00fcr dich.",
      fr: "Vous voulez une recommandation personnalis\u00e9e\u202f? Je trouverai le mod\u00e8le qui vous convient.",
      nl: "Wil je een persoonlijke aanbeveling? Ik vind het juiste model voor je.",
    },
    gm2: {
      en: "Questions about the Gym Monster 2? I can help with sizing, financing, or Mid-Year savings.",
      de: "Fragen zum Gym Monster 2? Ich helfe gerne bei Gr\u00f6\u00dfe, Finanzierung oder Jahresmitte-Spar-Aktionen.",
      fr: "Des questions sur le Gym Monster 2\u202f? Je peux vous aider sur la taille, le financement, ou les Soldes de Mi-Ann\u00e9e.",
      nl: "Vragen over de Gym Monster 2? Ik help met afmetingen, financiering of Midjaar-aanbiedingen.",
    },
    cart: {
      en: "Stuck on something? I can apply a code or arrange Klarna finance.",
      de: "H\u00e4ngst du irgendwo fest? Ich kann einen Code anwenden oder Klarna-Finanzierung einrichten.",
      fr: "Bloqu\u00e9 quelque part\u202f? Je peux appliquer un code ou organiser un financement Klarna.",
      nl: "Ergens vastgelopen? Ik kan een code toepassen of Klarna-financiering regelen.",
    },
    demo: {
      en: "Ready to book? Let\u2019s pick a time.",
      de: "Bereit zu buchen? Lass uns einen Termin finden.",
      fr: "Pr\u00eat \u00e0 r\u00e9server\u202f? Choisissons une date.",
      nl: "Klaar om te boeken? Laten we een tijd kiezen.",
    },
    blog: {
      en: "Reading up on Speediance? Drop a question if anything piques your interest.",
      de: "Liest du unseren Blog? Frag gerne, wenn dich etwas interessiert.",
      fr: "Vous lisez notre blog\u202f? N\u2019h\u00e9sitez pas si quelque chose vous int\u00e9resse.",
      nl: "Onze blog aan het lezen? Stel gerust een vraag als iets je interesse wekt.",
    },
  };

  function detectPageType() {
    const path = (location.pathname || "").toLowerCase();
    if (path.includes("/products/speediance-gym-monster-2")) return "gm2";
    // Homepage: "/" OR locale-prefixed root like "/fr", "/fr/", "/pt-pt/", "/de"
    if (path === "/" || /^\/[a-z]{2}(-[a-z]{2})?\/?$/.test(path)) return "home";
    if (path === "/cart" || path.startsWith("/cart/") || path === "/cart/") return "cart";
    if (path.includes("/pages/demo") || path.includes("/pages/book-a-demo") || path.includes("/pages/book-demo")) return "demo";
    if (path.includes("/blogs/") || path.includes("/articles/")) return "blog";
    return null;
  }

  let resizeTimer = null;

  function getElement(id) {
    return document.getElementById(id);
  }

  function isMobileViewport() {
    return window.matchMedia("(max-width: 767px)").matches;
  }

  function setAriaExpanded(expanded) {
    const toggleBtn = getElement(IDS.toggleBtn);
    if (toggleBtn) {
      toggleBtn.setAttribute("aria-expanded", expanded ? "true" : "false");
    }
  }

  function trackWidgetEvent(action, href) {
    const widget = getElement(IDS.widget);
    const payload = {
      event: "chat_widget_click",
      chat_widget_action: action,
      chat_widget_agent: widget?.dataset.agentName || "Jordan",
      chat_widget_region: widget?.dataset.region || "EU",
      chat_widget_href: href || "",
    };
    if (Array.isArray(window.dataLayer)) {
      window.dataLayer.push(payload);
    }
    if (typeof window.gtag === "function") {
      window.gtag("event", "chat_widget_click", {
        action,
        agent: payload.chat_widget_agent,
        region: payload.chat_widget_region,
        href: payload.chat_widget_href,
      });
    }
  }

  function showMinimizedState() {
    const widget = getElement(IDS.widget);
    const minimizedIcon = getElement(IDS.minimizedIcon);
    const chatBox = getElement(IDS.chatBox);
    if (widget) widget.style.display = "none";
    if (minimizedIcon) minimizedIcon.style.display = "block";
    if (chatBox) chatBox.style.display = "none";
    setAriaExpanded(false);
  }

  function detectPreferredLangFromShopify() {
    const fromLiquid = (window.SHOP_LOCALE || "").toLowerCase();
    const fromHtml = (document.documentElement.lang || "").toLowerCase();
    const raw = fromLiquid || fromHtml || "en";
    const base = raw.split("-")[0];
    // Direct supported locales
    const direct = { en: "en", de: "de", fr: "fr", nl: "nl" };
    if (direct[base]) return direct[base];
    // Regional/related fallbacks for unsupported locales — map to closest supported language
    // so a Luxembourgish, Italian, Spanish, etc. visitor lands on something useful.
    const fallback = {
      lb: "de",  // Luxembourgish speakers fluent in German
      it: "en",  // Italian — fall back to English (could add IT translations later)
      es: "en", "pt-pt": "en", pt: "en",
      el: "en", bg: "en", tr: "en", hr: "en", sl: "en",
      lt: "en", lv: "en", et: "en", mt: "en", ro: "en",
      sv: "en", da: "en", no: "en", fi: "en",
    };
    return fallback[raw] || fallback[base] || "en";
  }


  function isFranceMarket() {
    const shopCountry = ((window.Shopify && window.Shopify.country) || window.SHOP_COUNTRY || "").toUpperCase();
    const host = ((window.SHOP_HOST || location.hostname || "") + "").toLowerCase();
    return shopCountry === "FR" || host === "speediance.fr" || host.endsWith(".speediance.fr");
  }

  function getSalesWaNumber() {
    return isFranceMarket() ? "3197010205575" : "3197010205575";
  }

  function applyMarketAgentOverride(translation, currentLang) {
    if (!isFranceMarket()) return translation;
    const languageBits = {
      en: { greeting: "Hi, I'm Melissa 👋", chatWith: "Chat With Melissa" },
      de: { greeting: "Hallo, ich bin Melissa 👋", chatWith: "Chatte mit Melissa" },
      fr: { greeting: "Bonjour, je suis Melissa 👋", chatWith: "Discuter avec Melissa" },
      nl: { greeting: "Hallo, ik ben Melissa 👋", chatWith: "Chat met Melissa" },
    };
    const bits = languageBits[currentLang] || languageBits.en;
    return {
      ...translation,
      ...bits,
      image: "https://ca.slack-edge.com/T07RVMBGA2V-U0ALF3NG2R3-b86b134adc5f-512",
      bookDemoUrl: "https://cal.futuremvmt.com/melissa/full-demo",
      supportUrl: "https://speediance.fr/pages/contact",
    };
  }

  function updateLanguage(lang) {
    const currentLang = Object.prototype.hasOwnProperty.call(waTranslations, lang) ? lang : "en";
    const t = applyMarketAgentOverride(waTranslations[currentLang], currentLang);
    const chatWaHref = "https://wa.me/" + getSalesWaNumber() + "?text=" + encodeURIComponent(isFranceMarket() ? "Hi Melissa, I'm interested in Speediance" : "Hi, I'm interested in Speediance");
    const widget = getElement(IDS.widget);
    const selector = getElement(IDS.languageSwitch);
    const dn = getElement("dynamic-name");
    const hh = getElement("hookHeader");
    const bd = getElement("bookDemo");
    const cw = getElement("chatWa");
    const sp = getElement("supportBtn");
    const rl = getElement("roleLabel");
    const cl = getElement("chatWithLabel");
    const ai = getElement("agent-image");
    const ab = getElement("agent-image-box");

    if (dn) dn.innerText = t.greeting;
    if (hh) {
      const pageType = detectPageType();
      const pageHook = pageType && pageHooks[pageType] && pageHooks[pageType][currentLang];
      hh.innerText = pageHook || t.hookHeader;
    }
    if (bd) { bd.innerText = t.bookDemo; bd.href = t.bookDemoUrl; }
    if (cw) { cw.innerText = t.chatWa; cw.href = chatWaHref; }
    if (sp) { sp.innerText = t.support; sp.href = t.supportUrl; }
    if (rl) rl.innerText = t.role;
    if (cl) cl.innerText = t.chatWith;
    if (ai) ai.src = t.image;
    if (ab) ab.src = t.image;
    if (widget) widget.dataset.agentName = t.chatWith.replace(/^Chat(?:te| met| With| Discuter avec)\s+/i, "").trim() || "Jordan";
    if (selector) selector.value = currentLang;
    localStorage.setItem(STORAGE_KEYS.language, currentLang);
  }

  function applyResponsiveState() {
    const widget = getElement(IDS.widget);
    const toggleBtn = getElement(IDS.toggleBtn);
    const chatBox = getElement(IDS.chatBox);
    const minimizedIcon = getElement(IDS.minimizedIcon);
    const isMinimized = sessionStorage.getItem(STORAGE_KEYS.minimized) === "1";
    const isMobile = isMobileViewport();
    if (!widget || !toggleBtn || !chatBox || !minimizedIcon) return;

    if (isMinimized) {
      showMinimizedState();
      return;
    }

    widget.style.display = "block";
    minimizedIcon.style.display = "none";
    widget.classList.add("widget-ready");

    if (isMobile) {
      toggleBtn.style.display = "flex";
      const shouldOpen = sessionStorage.getItem(STORAGE_KEYS.mobileOpen) === "1";
      chatBox.style.display = shouldOpen ? "block" : "none";
      setAriaExpanded(shouldOpen);
      return;
    }

    toggleBtn.style.display = "none";
    chatBox.style.display = "block";
    sessionStorage.removeItem(STORAGE_KEYS.mobileOpen);
    setAriaExpanded(true);
  }

  function toggleChatBox() {
    if (!isMobileViewport()) return;
    const chatBox = getElement(IDS.chatBox);
    if (!chatBox) return;
    const shouldOpen = chatBox.style.display !== "block";
    chatBox.style.display = shouldOpen ? "block" : "none";
    setAriaExpanded(shouldOpen);
    if (shouldOpen) {
      sessionStorage.setItem(STORAGE_KEYS.mobileOpen, "1");
      trackWidgetEvent("toggle_open");
      return;
    }
    sessionStorage.removeItem(STORAGE_KEYS.mobileOpen);
    trackWidgetEvent("toggle_close");
  }

  function minimizeChatWidget() {
    sessionStorage.setItem(STORAGE_KEYS.minimized, "1");
    sessionStorage.removeItem(STORAGE_KEYS.mobileOpen);
    showMinimizedState();
    trackWidgetEvent("minimize");
  }

  function restoreChatWidget() {
    sessionStorage.removeItem(STORAGE_KEYS.minimized);
    applyResponsiveState();
    trackWidgetEvent("restore");
  }

  function handleTrackedClick(event) {
    const target = event.currentTarget;
    const action = target?.dataset.chatAction;
    if (!action) return;
    trackWidgetEvent(action, target.href || "");
  }

  function handleSalesClick(event) {
    handleTrackedClick(event);
    minimizeChatWidget();
  }

  function init() {
    if (document.body?.dataset.chatWidgetInitialized === "true") return;
    document.body.dataset.chatWidgetInitialized = "true";

    // Explicit user override wins (set only via dropdown). Otherwise always use the
    // current page locale — so navigating from /en/ to /fr/ updates the widget.
    const explicitOverride = localStorage.getItem(STORAGE_KEYS.languageOverride);
    const initialLang = explicitOverride || detectPreferredLangFromShopify();
    updateLanguage(initialLang);

    getElement(IDS.closeBtn)?.addEventListener("click", minimizeChatWidget);
    getElement(IDS.toggleBtn)?.addEventListener("click", toggleChatBox);
    getElement(IDS.minimizedIcon)?.addEventListener("click", restoreChatWidget);
    getElement("chatWa")?.addEventListener("click", handleSalesClick);
    document.querySelectorAll("[data-chat-action]").forEach((link) => {
      if (link.id === "chatWa") return;
      link.addEventListener("click", handleTrackedClick);
    });
    getElement(IDS.languageSwitch)?.addEventListener("change", function () {
      // Mark this as an explicit user choice — sticks across page navigation.
      localStorage.setItem(STORAGE_KEYS.languageOverride, this.value);
      updateLanguage(this.value);
      trackWidgetEvent("language_change", this.value);
    });
    window.addEventListener("resize", () => {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(applyResponsiveState, 120);
    });

    applyResponsiveState();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();

/* ─────────────────────────────────────────────────────────────────────────
 * Speediance chat widget — enhancement 2026-04-20.4
 *
 * Visual-first attention grab + best-effort audio chime.
 *
 * On first user interaction (scroll/click/touch):
 *   • Widget wiggles
 *   • Pulsing green halo runs around the WhatsApp button until dismissed
 *   • Red "1" notification badge on the WA button (like an unread message)
 *   • Speech-bubble tooltip slides out: "Got questions? I'm here →"
 *   • Audio chime plays (if the browser allows it — Chrome/Safari allow
 *     once a user gesture has occurred, which scroll/click satisfies)
 *
 * All effects stop the instant the user clicks any CTA (they've converted).
 *
 * Also:
 *   • Moves "Chat on WhatsApp" to the TOP of the CTA list
 *   • Renames "Book a Demo With Me" → "Book a Demo/Call With Me" (EN+DE+FR+NL)
 *
 * Debug API: window.chatWidgetEnhance.testBeep() / .testWiggle() / .reset()
 * ─────────────────────────────────────────────────────────────────────── */
(function enhanceChatWidget() {
  "use strict";

  var BEEP_KEY  = "chatWidgetBeeped-v4";
  var BADGE_KEY = "chatWidgetBadge-v4";
  var CONVERTED = "chatWidgetConverted-v4";
  var reducedMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var LOG_PREFIX = "[chat-widget-enhance]";

  var demoRenames = [
    [/Book a Demo With Me/i,        "Book a Demo/Call With Me"],
    [/Demo mit mir buchen/i,        "Demo oder Anruf mit mir buchen"],
    [/Réserver une démo avec moi/i, "Réserver une démo ou un appel avec moi"],
    [/Boek een demo met mij/i,      "Boek een demo of gesprek met mij"],
  ];

  function log() { try { console.log.apply(console, [LOG_PREFIX].concat([].slice.call(arguments))); } catch (e) {} }

  function applyDemoRename(el) {
    if (!el) return;
    var t = el.textContent;
    for (var i = 0; i < demoRenames.length; i++) {
      if (demoRenames[i][0].test(t)) { el.textContent = t.replace(demoRenames[i][0], demoRenames[i][1]); return; }
    }
  }

  function normaliseAuSalesClass(widget) {
    if (!widget) return;
    var sales = widget.querySelector('.cta-sales');
    if (sales && !widget.querySelector('.cta-whatsapp')) {
      sales.classList.remove('cta-sales');
      sales.classList.add('cta-whatsapp');
      // Replace "Chat with Sales" → "Chat on WhatsApp" (AU store legacy label)
      if (/Chat with Sales/i.test(sales.textContent)) {
        sales.textContent = sales.textContent.replace(/Chat with Sales/i, 'Chat on WhatsApp');
      }
    }
  }

  function reorderCtas(cta) {
    if (!cta) return;
    var wa      = cta.querySelector(".cta-whatsapp");
    var demo    = cta.querySelector(".cta-demo");
    var support = cta.querySelector(".cta-support");
    if (wa      && cta.firstElementChild !== wa)                 cta.insertBefore(wa, cta.firstElementChild);
    if (demo    && wa && demo.previousElementSibling !== wa)     cta.insertBefore(demo, wa.nextElementSibling);
    if (support && cta.lastElementChild !== support)             cta.appendChild(support);
  }

  function injectStyles() {
    if (document.getElementById("chat-widget-enhance-css")) return;
    var style = document.createElement("style");
    style.id = "chat-widget-enhance-css";
    style.appendChild(document.createTextNode(
      "@keyframes chatEnhanceWiggle{" +
      " 0%,100%{transform:rotate(0)}15%{transform:rotate(-10deg)}30%{transform:rotate(9deg)}45%{transform:rotate(-6deg)}60%{transform:rotate(4deg)}78%{transform:rotate(-2deg)}}" +
      ".chat-wiggle{animation:chatEnhanceWiggle 1s cubic-bezier(.36,.07,.19,.97);transform-origin:center}" +
      "@keyframes chatEnhanceHalo{" +
      " 0%{box-shadow:0 0 0 0 rgba(37,211,102,.7)}" +
      " 70%{box-shadow:0 0 0 18px rgba(37,211,102,0)}" +
      " 100%{box-shadow:0 0 0 0 rgba(37,211,102,0)}" +
      "}" +
      ".cta-buttons a.cta-whatsapp.chat-halo{animation:chatEnhanceHalo 1.6s ease-out infinite;position:relative}" +
      ".cta-buttons a.cta-whatsapp{background:linear-gradient(135deg,#25D366,#075E54)!important;box-shadow:0 4px 14px rgba(37,211,102,.45);font-weight:600;position:relative;color:#fff}" +
      ".chat-badge{position:absolute;top:-6px;right:-6px;min-width:20px;height:20px;padding:0 5px;background:#ef4444;color:#fff;font-size:12px;font-weight:800;line-height:20px;border-radius:10px;text-align:center;box-shadow:0 2px 6px rgba(239,68,68,.55);pointer-events:none;animation:chatBadgePop .5s cubic-bezier(.34,1.56,.64,1)}" +
      "@keyframes chatBadgePop{0%{transform:scale(0)}100%{transform:scale(1)}}" +
      "#chat-enhance-bubble{position:absolute;bottom:calc(100% + 14px);right:0;max-width:240px;padding:10px 14px;background:#111827;color:#fff;font-size:13px;line-height:1.35;border-radius:14px 14px 2px 14px;box-shadow:0 8px 24px rgba(0,0,0,.28);opacity:0;transform:translateY(6px) scale(.96);transition:opacity .25s ease,transform .25s ease;pointer-events:auto;z-index:10}" +
      "#chat-enhance-bubble.show{opacity:1;transform:translateY(0) scale(1)}" +
      "#chat-enhance-bubble::after{content:\"\";position:absolute;bottom:-6px;right:18px;width:12px;height:12px;background:#111827;transform:rotate(45deg)}" +
      "#chat-enhance-bubble .close{position:absolute;top:2px;right:6px;background:none;border:0;color:#9ca3af;font-size:16px;line-height:1;cursor:pointer;padding:2px 4px}" +
      "#chat-enhance-bubble .close:hover{color:#fff}" +
      "@media (prefers-reduced-motion: reduce){.chat-wiggle,.cta-buttons a.cta-whatsapp.chat-halo,.chat-badge{animation:none!important}}"
    ));
    (document.head || document.documentElement).appendChild(style);
    log("styles injected");
  }

  // Shared AudioContext — must be created under user gesture
  var sharedCtx = null;
  function ensureAudioCtx() {
    if (sharedCtx) {
      if (sharedCtx.state === "suspended" && typeof sharedCtx.resume === "function") {
        return sharedCtx.resume().then(function () { return sharedCtx; });
      }
      return Promise.resolve(sharedCtx);
    }
    var Ctx = window.AudioContext || window.webkitAudioContext;
    if (!Ctx) return Promise.reject(new Error("no AudioContext"));
    sharedCtx = new Ctx();
    // iOS/Safari unlock: play a silent one-sample buffer within user gesture
    try {
      var s = sharedCtx.createBufferSource();
      s.buffer = sharedCtx.createBuffer(1, 1, sharedCtx.sampleRate);
      s.connect(sharedCtx.destination);
      s.start(0);
    } catch (e) {}
    if (sharedCtx.state === "suspended" && typeof sharedCtx.resume === "function") {
      return sharedCtx.resume().then(function () { return sharedCtx; });
    }
    return Promise.resolve(sharedCtx);
  }

  function playChime(opts) {
    opts = opts || {};
    if (!opts.force && (sessionStorage.getItem(BEEP_KEY) === "1" || reducedMotion)) return;
    ensureAudioCtx().then(function (ctx) {
      if (!ctx || ctx.state !== "running") { log("audio ctx not running:", ctx && ctx.state); return; }
      var now = ctx.currentTime;
      // Master gain with a compressor so the peaks land LOUD (0.8) without clipping
      var comp = ctx.createDynamicsCompressor();
      comp.threshold.value = -12;
      comp.knee.value = 8;
      comp.ratio.value = 3;
      comp.attack.value = 0.003;
      comp.release.value = 0.12;
      comp.connect(ctx.destination);
      function note(freq, start, dur, peak) {
        var osc = ctx.createOscillator();
        var gain = ctx.createGain();
        osc.type = "triangle";
        osc.frequency.value = freq;
        osc.connect(gain); gain.connect(comp);
        gain.gain.setValueAtTime(0.0001, now + start);
        gain.gain.exponentialRampToValueAtTime(peak, now + start + 0.012);
        gain.gain.exponentialRampToValueAtTime(0.0001, now + start + dur);
        osc.start(now + start);
        osc.stop(now + start + dur + 0.05);
      }
      // C6 → E6 → G6 — classic ascending triad, loud peaks
      note(1047, 0.00, 0.22, 0.85);
      note(1319, 0.12, 0.26, 0.80);
      note(1568, 0.26, 0.34, 0.75);
      sessionStorage.setItem(BEEP_KEY, "1");
      log("chime played");
    }).catch(function (err) { log("chime error", err && err.message); });
  }

  function isVisible(el) {
    if (!el) return false;
    var cs = window.getComputedStyle(el);
    if (cs.display === "none" || cs.visibility === "hidden") return false;
    return el.offsetWidth > 0 || el.offsetHeight > 0;
  }

  function wiggleWidget() {
    var widget = document.getElementById("custom-chat-widget");
    var toggle = document.getElementById("chat-toggle-btn");
    var mini   = document.getElementById("minimized-widget-icon");
    [widget, toggle, mini].forEach(function (el) {
      if (!isVisible(el)) return;
      el.classList.remove("chat-wiggle");
      void el.offsetWidth;
      el.classList.add("chat-wiggle");
      setTimeout(function () { el.classList.remove("chat-wiggle"); }, 1000);
    });
  }

  function ensureHalo() {
    var wa = document.querySelector("#custom-chat-widget .cta-whatsapp");
    if (wa) wa.classList.add("chat-halo");
  }
  function stopHalo() {
    var wa = document.querySelector("#custom-chat-widget .cta-whatsapp");
    if (wa) wa.classList.remove("chat-halo");
  }

  function ensureBadge() {
    if (sessionStorage.getItem(BADGE_KEY) === "dismissed") return;
    var wa = document.querySelector("#custom-chat-widget .cta-whatsapp");
    if (!wa || wa.querySelector(".chat-badge")) return;
    var badge = document.createElement("span");
    badge.className = "chat-badge";
    badge.setAttribute("aria-hidden", "true");
    badge.textContent = "1";
    wa.appendChild(badge);
  }

  function clearBadge() {
    sessionStorage.setItem(BADGE_KEY, "dismissed");
    var badge = document.querySelector("#custom-chat-widget .cta-whatsapp .chat-badge");
    if (badge) badge.remove();
  }

  var bubbleEl = null;
  function ensureBubble() {
    if (bubbleEl || sessionStorage.getItem("chatWidgetBubbleDismissed-v4") === "1") return;
    var widget = document.getElementById("custom-chat-widget");
    if (!widget) return;
    bubbleEl = document.createElement("div");
    bubbleEl.id = "chat-enhance-bubble";
    bubbleEl.innerHTML = '<button class="close" type="button" aria-label="Dismiss">&times;</button>' +
      '<strong>Got questions?</strong><br>Message us on WhatsApp — we usually reply within a few minutes.';
    widget.appendChild(bubbleEl);
    bubbleEl.querySelector(".close").addEventListener("click", function (e) {
      e.stopPropagation();
      dismissBubble();
    });
    // Show after a small delay so the entrance is noticed
    requestAnimationFrame(function () { setTimeout(function () { bubbleEl.classList.add("show"); }, 200); });
  }

  function dismissBubble() {
    sessionStorage.setItem("chatWidgetBubbleDismissed-v4", "1");
    if (!bubbleEl) return;
    bubbleEl.classList.remove("show");
    setTimeout(function () { if (bubbleEl && bubbleEl.parentNode) bubbleEl.parentNode.removeChild(bubbleEl); bubbleEl = null; }, 260);
  }

  function hasConverted() { return sessionStorage.getItem(CONVERTED) === "1"; }
  function markConverted() { sessionStorage.setItem(CONVERTED, "1"); }

  function fireAttentionBurst() {
    if (hasConverted()) return;
    wiggleWidget();
    ensureHalo();
    ensureBadge();
    ensureBubble();
    playChime();
  }

  function scheduleAttentionNudge() {
    if (hasConverted() || reducedMotion) { log("skip nudge"); return; }

    var userInteracted = false;
    var firstTimer = null;
    var repeatTimer = null;

    function onInteract() {
      if (userInteracted) return;
      userInteracted = true;
      log("first interaction seen");
      ensureAudioCtx(); // warm up audio context inside gesture
      firstTimer = setTimeout(function () {
        if (hasConverted()) return;
        fireAttentionBurst();
      }, 1000);

      // Persistent silent wiggles at 45s and 90s
      repeatTimer = setTimeout(function rep1() {
        if (hasConverted()) return;
        wiggleWidget();
        repeatTimer = setTimeout(function rep2() {
          if (hasConverted()) return;
          wiggleWidget();
        }, 45000);
      }, 45000);
    }

    ["click", "scroll", "touchstart", "keydown", "pointerdown"].forEach(function (ev) {
      window.addEventListener(ev, onInteract, { passive: true, once: true });
    });

    // On CTA click → stop everything
    document.querySelectorAll("[data-chat-action]").forEach(function (el) {
      el.addEventListener("click", function () {
        markConverted();
        if (firstTimer) clearTimeout(firstTimer);
        if (repeatTimer) clearTimeout(repeatTimer);
        stopHalo();
        clearBadge();
        dismissBubble();
        log("converted — nudges off");
      }, { once: true });
    });
  }

  var applied = false;
  function apply() {
    var widget = document.getElementById("custom-chat-widget");
    if (!widget) return false;
    var cta = widget.querySelector(".cta-buttons");
    if (!cta) return false;
    injectStyles();
    normaliseAuSalesClass(widget);
    reorderCtas(cta);
    applyDemoRename(cta.querySelector(".cta-demo"));
    var demo = cta.querySelector(".cta-demo");
    if (demo && !demo.__chatRenameObs) {
      var mo = new MutationObserver(function () { applyDemoRename(demo); });
      mo.observe(demo, { characterData: true, childList: true, subtree: true });
      demo.__chatRenameObs = mo;
    }
    if (!applied) {
      applied = true;
      scheduleAttentionNudge();
      log("apply complete");
    }
    return true;
  }

  function start() {
    if (apply()) return;
    var attempts = 0;
    var iv = setInterval(function () {
      attempts += 1;
      if (apply() || attempts > 50) clearInterval(iv);
    }, 100);
    log("polling for widget");
  }

  // Debug API
  window.chatWidgetEnhance = {
    testBeep:   function () { playChime({ force: true }); },
    testWiggle: function () { wiggleWidget(); },
    fire:       function () { fireAttentionBurst(); },
    reset:      function () {
      sessionStorage.removeItem(BEEP_KEY);
      sessionStorage.removeItem(BADGE_KEY);
      sessionStorage.removeItem(CONVERTED);
      sessionStorage.removeItem("chatWidgetBubbleDismissed-v4");
      log("session state cleared");
    },
  };

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start);
  else start();
})();



/* ──────────────────────────────────────────────────────────────────────────
 * Speediance EU chat widget — INLINE BOOKING with country routing  2026-06-26
 *
 * Appended to the EU assets/chat.js. Adds, with NO markup change:
 *   1. A live "Next available" teaser under the booking CTA (localized
 *      EN/FR/DE), pre-routed to the right agent from the detected country +
 *      language. Fed by crm.futuremvmt.com/cal/next-slot?agent=...
 *   2. An inline booking panel that REPLACES the chat options:
 *        Step A — confirm country (pre-filled from Shopify localization)
 *        Step B — 15-min call / 30-min demo toggle over the routed agent's
 *                 real Cal.com calendar (inline embed). Back navigates A<-B.
 *
 * Agent routing (per Luke, 2026-06-26):
 *   • France / Monaco, OR French language          → Melissa
 *   • German language, OR AT / CH / LI (German EU)  → Marco
 *   • everything else (NL/IE/English/Dutch/rest)    → Jordan
 *   Germany (DE) is NOT a market we sell to — excluded from the picker.
 *
 * Coexists with the EU widget's own i18n: re-applies the CTA label + teaser
 * after updateLanguage() re-renders on a language switch. UI strings EN/FR/DE
 * (NL + everything else fall back to English). Debug: window.bmBookingEU.
 * ────────────────────────────────────────────────────────────────────────── */
(function bmInlineBookingEU() {
  "use strict";
  if (window.__bmInlineBookingEU) return;
  window.__bmInlineBookingEU = true;

  var CAL_ORIGIN = "https://cal.futuremvmt.com";
  var NEXT_SLOT_URL = "https://crm.futuremvmt.com/cal/next-slot";
  var GEO_TIMEOUT_MS = 500;
  var BRAND = "#1166FF";

  var AGENTS = {
    melissa: { name: "Melissa", cal: "melissa", img: "https://ca.slack-edge.com/T07RVMBGA2V-U0ALF3NG2R3-b86b134adc5f-512" },
    marco:   { name: "Marco",   cal: "marco",   img: "https://storage.googleapis.com/msgsndr/qO7EpNj95iLIcx6VzjRK/media/6834c222016c699e4af78224.jpeg" },
    jordan:  { name: "Jordan",  cal: "jordan",  img: "https://storage.googleapis.com/msgsndr/gs8BnQHT0c6ZesS8QkWf/media/689c9db41f951e79f66a960c.jpeg" },
  };
  // Only FRANCE the country forces Melissa (matches the existing widget's FR
  // override). Monaco + everywhere else follow LANGUAGE first (de->Marco,
  // fr->Melissa, en/nl->Jordan), then country for German-speaking markets.
  var FRENCH_C = { FR: 1 };
  var GERMAN_C = { AT: 1, CH: 1, LI: 1 };
  // Served EU markets, used only if Liquid didn't expose the real list. Germany excluded.
  var FALLBACK_COUNTRIES = ["FR", "MC", "AT", "CH", "LI", "BE", "LU", "NL", "IE", "IT", "ES", "PT"];

  var I18N = {
    en: { cta: "Book a quick call or demo", next: "Next available:", soon: "in the next 2 hours", today: "today", tomorrow: "tomorrow",
      where: "Where are you based?", hint: "We’ll connect you with the right specialist.", cont: "Continue",
      bookWith: "Book with", call: "15-min call", callSub: "Phone", demo: "30-min demo", demoSub: "Video call",
      tz: "Times shown in your timezone", loading: "Loading the calendar…", detecting: "Detecting your country…", openPage: "Open booking page ↗", miniMsg: "Still here — book a quick call or demo", miniCta: "Book a time →" },
    fr: { cta: "Réserver un appel ou une démo", next: "Prochain créneau :", soon: "dans les 2 prochaines heures", today: "aujourd’hui", tomorrow: "demain",
      where: "Où êtes-vous situé ?", hint: "Nous vous mettons en relation avec le bon spécialiste.", cont: "Continuer",
      bookWith: "Réserver avec", call: "Appel 15 min", callSub: "Téléphone", demo: "Démo 30 min", demoSub: "Appel vidéo",
      tz: "Heures dans votre fuseau horaire", loading: "Chargement du calendrier…", detecting: "Détection de votre pays…", openPage: "Ouvrir la page de réservation ↗", miniMsg: "Toujours là — réservez un appel ou une démo", miniCta: "Choisir un horaire →" },
    de: { cta: "Anruf oder Demo buchen", next: "Nächster Termin:", soon: "in den nächsten 2 Stunden", today: "heute", tomorrow: "morgen",
      where: "Wo befindest du dich?", hint: "Wir verbinden dich mit dem richtigen Spezialisten.", cont: "Weiter",
      bookWith: "Termin mit", call: "15-Min-Anruf", callSub: "Telefon", demo: "30-Min-Demo", demoSub: "Videoanruf",
      tz: "Zeiten in deiner Zeitzone", loading: "Kalender wird geladen…", detecting: "Dein Land wird erkannt…", openPage: "Buchungsseite öffnen ↗", miniMsg: "Noch da — buche einen Anruf oder eine Demo", miniCta: "Termin wählen →" },
  };

  var widget = null, panel = null, selectedEvent = "quick_call", bookingAgent = "jordan", calLoaded = false;
  var geoCountry = "", geoCountryDone = false, geoCountryPromise = null;
  var embedFailTimer = null, lastRendered = "";
  var miniNudgeEl = null, miniNudgePending = false;
  // chat-options greeting (4 langs incl nl) for the minimized-launcher nudge name
  var HI = { en: "Hi, I'm ", fr: "Bonjour, je suis ", de: "Hallo, ich bin ", nl: "Hallo, ik ben " };

  function icPhone() { return '<svg viewBox="0 0 24 24" width="17" height="17" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.13.96.36 1.9.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.91.34 1.85.57 2.81.7A2 2 0 0 1 22 16.92z"/></svg>'; }
  function icVideo() { return '<svg viewBox="0 0 24 24" width="17" height="17" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polygon points="23 7 16 12 23 17 23 7"/><rect x="1" y="5" width="15" height="14" rx="2" ry="2"/></svg>'; }
  function icCal() { return '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>'; }
  function icBack() { return '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="15 18 9 12 15 6"/></svg>'; }
  function icClose() { return '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>'; }
  function icArrow() { return '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>'; }

  // rawLang = the widget's actual language (en/de/fr/nl) — used for the chat
  // header + agent routing. bookingLang = en/fr/de only (nl + others -> en) —
  // used for the booking-panel UI strings, per spec.
  function rawLang() {
    var sel = document.getElementById("language-switch");
    var raw = (sel && sel.value) || "";
    if (!raw) { try { raw = localStorage.getItem("euChatWidgetLangOverride") || localStorage.getItem("euChatWidgetLang") || ""; } catch (e) {} }
    if (!raw) raw = window.SHOP_LOCALE || document.documentElement.lang || "en";
    raw = String(raw).toLowerCase().split("-")[0];
    return ({ en: 1, de: 1, fr: 1, nl: 1 }[raw]) ? raw : "en";
  }
  function bookingLang() { var l = rawLang(); return (l === "fr" || l === "de") ? l : "en"; }
  function lang() { return bookingLang(); }
  function L() { return I18N[bookingLang()]; }

  // The chat-options header agent is owned by the EXISTING EU widget and is
  // language-driven (de->Marco, fr->Melissa, en/nl->Jordan, + FR country->Melissa).
  // We do NOT override it — we just read whichever agent it is currently showing
  // (via data-agent-name, which updateLanguage sets) so the teaser stays in sync
  // and changes when the visitor switches language.
  function displayedAgentKey() {
    var country = detectedCountry();
    var host = String(window.SHOP_HOST || location.hostname || "").toLowerCase();
    if (country === "FR" || host === "speediance.fr" || host.indexOf(".speediance.fr") >= 0) return "melissa";
    var lg = rawLang();
    if (lg === "fr") return "melissa";
    if (lg === "de") return "marco";
    return "jordan";
  }

  function normCountry(c) {
    c = String(c || "").trim().toUpperCase();
    return /^[A-Z]{2}$/.test(c) ? c : "";
  }
  function shopifyCountry() {
    return normCountry((window.Shopify && window.Shopify.country) || window.SHOP_COUNTRY || "");
  }
  function geoLookupUrl() {
    var base = "https://crm.futuremvmt.com/dashboard-api";
    try {
      if (window.BlackMirrorGeo && window.BlackMirrorGeo.apiBase) base = window.BlackMirrorGeo.apiBase;
    } catch (e) {}
    return String(base).replace(/\/+$/, "") + "/api/public/geo-lookup?store=eu";
  }
  function fetchGeoCountry() {
    if (geoCountryDone) return Promise.resolve(geoCountry);
    if (geoCountryPromise) return geoCountryPromise;
    if (typeof window.fetch !== "function") {
      geoCountryDone = true;
      return Promise.resolve("");
    }
    var ctrl = ("AbortController" in window) ? new AbortController() : null;
    geoCountryPromise = new Promise(function (resolve) {
      var settled = false;
      function finish(country) {
        if (settled) return;
        settled = true;
        clearTimeout(to);
        geoCountryDone = true;
        geoCountry = normCountry(country);
        resolve(geoCountry);
      }
      var to = setTimeout(function () {
        if (ctrl) ctrl.abort();
        finish("");
      }, GEO_TIMEOUT_MS);
      fetch(geoLookupUrl(), ctrl ? { signal: ctrl.signal, cache: "no-store", credentials: "omit" } : { cache: "no-store", credentials: "omit" })
        .then(function (r) { return r && r.ok ? r.json() : null; })
        .then(function (j) { finish(j && j.country); })
        .catch(function () { finish(""); });
    });
    return geoCountryPromise;
  }
  function detectedCountry() {
    return geoCountry || shopifyCountry();
  }
  function routeAgent(country, lg) {
    country = String(country || "").toUpperCase();
    if (FRENCH_C[country]) return "melissa";
    if (lg === "fr") return "melissa";
    if (lg === "de" || GERMAN_C[country]) return "marco";
    return "jordan";
  }

  function visitorTz() {
    try { return Intl.DateTimeFormat().resolvedOptions().timeZone || "Europe/Paris"; } catch (e) { return "Europe/Paris"; }
  }
  function dateKey(d, tz) { return d.toLocaleDateString("en-CA", { timeZone: tz }); }
  function timePart(d, lg, tz) {
    var loc = lg === "en" ? "en-US" : (lg === "de" ? "de-DE" : "fr-FR");
    var s = d.toLocaleTimeString(loc, { timeZone: tz, hour: lg === "en" ? "numeric" : "2-digit", minute: "2-digit", hour12: lg === "en" });
    return lg === "en" ? s.replace(/\s/g, "").toLowerCase() : s;
  }
  function teaserLabel(iso, tz) {
    var t = L(), lg = lang(), slot = new Date(iso), now = new Date(), delta = slot.getTime() - now.getTime();
    var tp = timePart(slot, lg, tz);
    if (delta <= 2 * 60 * 60 * 1000) return t.soon;
    var todayK = dateKey(now, tz), tomK = dateKey(new Date(now.getTime() + 86400000), tz), slotK = dateKey(slot, tz);
    if (slotK === todayK) return t.today + " " + tp;
    if (slotK === tomK) return t.tomorrow + " " + tp;
    var loc = lg === "en" ? "en-GB" : (lg === "de" ? "de-DE" : "fr-FR");
    return slot.toLocaleDateString(loc, { timeZone: tz, weekday: "short" }) + " " + tp;
  }

  function track(action) {
    var payload = { event: "chat_widget_click", chat_widget_action: action, chat_widget_agent: bookingAgent, chat_widget_region: "EU" };
    try { if (Array.isArray(window.dataLayer)) window.dataLayer.push(payload); } catch (e) {}
    try { if (typeof window.gtag === "function") window.gtag("event", "chat_widget_click", { action: action, agent: bookingAgent, region: "EU" }); } catch (e) {}
  }

  function injectStyles() {
    if (document.getElementById("bm-booking-eu-css")) return;
    var s = document.createElement("style");
    s.id = "bm-booking-eu-css";
    s.appendChild(document.createTextNode([
      ".cta-demo{display:block!important;text-align:left!important}",
      ".cta-demo .bm-demo-main{display:flex;align-items:center;gap:8px;font-weight:600;line-height:1.2}",
      ".cta-demo .bm-demo-teaser{display:flex;align-items:center;gap:6px;margin-top:6px;padding-top:6px;border-top:1px solid rgba(255,255,255,.28);font-size:11.5px;font-weight:500;color:#e7f0ff}",
      ".cta-demo .bm-demo-teaser b{color:#fff;font-weight:600}",
      ".cta-demo .bm-dot{width:7px;height:7px;border-radius:50%;background:#77FF33;box-shadow:0 0 0 3px rgba(119,255,51,.3);flex:0 0 auto;animation:bmPulse 1.8s ease-out infinite}",
      "@keyframes bmPulse{0%{box-shadow:0 0 0 0 rgba(119,255,51,.45)}70%{box-shadow:0 0 0 7px rgba(119,255,51,0)}100%{box-shadow:0 0 0 0 rgba(119,255,51,0)}}",
      "#bm-eu-panel{position:fixed;bottom:30px;right:30px;z-index:10001;display:none;flex-direction:column;width:390px;max-width:calc(100vw - 24px);height:582px;max-height:calc(100vh - 56px);background:#fff;border-radius:18px;border-top:4px solid " + BRAND + ";box-shadow:0 18px 50px rgba(17,102,255,.22),0 6px 18px rgba(0,0,0,.12);overflow:hidden;font-family:'Inter',var(--font-body-family,sans-serif)}",
      "#bm-eu-panel.bm-on{display:flex;animation:bmIn .22s ease}",
      "@keyframes bmIn{from{opacity:0;transform:translateY(10px)}to{opacity:1;transform:translateY(0)}}",
      ".bm-head{display:flex;align-items:center;gap:8px;padding:12px 12px 10px;border-bottom:1px solid #eef0f3}",
      ".bm-iconbtn{display:inline-flex;align-items:center;justify-content:center;width:30px;height:30px;border-radius:8px;border:0;background:transparent;color:#475569;cursor:pointer;padding:0}",
      ".bm-iconbtn:hover{background:#f1f5f9;color:#0f172a}",
      ".bm-head .bm-av{width:26px;height:26px;border-radius:50%;object-fit:cover}",
      ".bm-head .bm-title{font-size:13.5px;font-weight:600;color:#0f172a}",
      ".bm-head .bm-x{margin-left:auto}",
      ".bm-step{flex:1;min-height:0;display:flex;flex-direction:column}",
      ".bm-country{padding:22px 18px;display:flex;flex-direction:column}",
      ".bm-country h3{font-size:15px;font-weight:600;color:#0f172a;margin:0 0 4px}",
      ".bm-country p{font-size:12px;color:#64748b;margin:0 0 16px;line-height:1.45}",
      ".bm-country select{appearance:none;-webkit-appearance:none;width:100%;font-size:14px;color:#0f172a;background:#f8fafc;border:1px solid #e2e8f0;border-radius:10px;padding:12px 38px 12px 13px;cursor:pointer;background-image:url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='%2364748b' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'><polyline points='6 9 12 15 18 9'/></svg>\");background-repeat:no-repeat;background-position:right 12px center}",
      ".bm-country select:focus-visible{outline:3px solid #0f172a;outline-offset:2px}",
      ".bm-continue{margin-top:16px;display:flex;align-items:center;justify-content:center;gap:8px;background:" + BRAND + ";color:#fff;border:0;border-radius:10px;padding:13px 14px;font-size:14px;font-weight:600;cursor:pointer}",
      ".bm-continue:hover{background:#0d54d6}",
      ".bm-continue:disabled{cursor:wait;opacity:.65}",
      ".bm-continue:focus-visible{outline:3px solid #0f172a;outline-offset:2px}",
      ".bm-seg{display:flex;gap:4px;margin:12px 12px 0;background:#f1f5f9;padding:4px;border-radius:11px}",
      ".bm-seg button{flex:1;display:flex;flex-direction:column;align-items:center;gap:1px;padding:8px 4px;border:0;border-radius:8px;background:transparent;color:#64748b;cursor:pointer;transition:background .15s,color .15s}",
      ".bm-seg button .bm-sub{font-size:10px;opacity:.85}",
      ".bm-seg button .bm-lbl{font-size:11.5px;font-weight:600}",
      ".bm-seg button[aria-pressed='true']{background:" + BRAND + ";color:#fff;box-shadow:0 2px 8px rgba(17,102,255,.35)}",
      ".bm-seg button:focus-visible{outline:3px solid #0f172a;outline-offset:2px}",
      ".bm-cal-host{position:relative;flex:1;min-height:0;overflow:auto;margin:10px 6px 6px;-webkit-overflow-scrolling:touch}",
      ".bm-cal-host .bm-loading{position:absolute;top:0;left:0;right:0;height:340px;display:flex;align-items:center;justify-content:center;color:#94a3b8;font-size:12.5px;z-index:0}",
      ".bm-cal-host #bm-eu-cal{position:relative;z-index:1;min-height:430px}",
      ".bm-foot{display:flex;align-items:center;gap:6px;padding:8px 14px 12px;font-size:10.5px;color:#94a3b8}",
      "@media (max-width:767px){#bm-eu-panel{left:8px;right:8px;bottom:8px;width:auto;max-width:none;height:86vh;height:86dvh;max-height:none}}",
      "#minimized-widget-icon.bm-mini{width:66px;height:66px;background:transparent;border:0;box-shadow:none;line-height:normal;font-size:0;overflow:visible;transition:transform .18s cubic-bezier(.23,1,.32,1)}",
      "#minimized-widget-icon.bm-mini .bm-mini-av{width:66px;height:66px;border-radius:50%;object-fit:cover;display:block;background:" + BRAND + ";border:3px solid #fff;box-shadow:0 8px 26px rgba(0,0,0,.30)}",
      "#minimized-widget-icon.bm-mini .bm-mini-wa{position:absolute;right:-3px;bottom:-3px;width:29px;height:29px;border-radius:50%;background:#25D366;border:3px solid #fff;box-shadow:0 2px 7px rgba(37,211,102,.45);display:flex;align-items:center;justify-content:center}",
      "#minimized-widget-icon.bm-mini .bm-mini-wa svg{width:17px;height:17px;display:block;fill:#fff}",
      "#minimized-widget-icon.bm-mini .bm-mini-pulse{position:absolute;inset:0;border-radius:50%;z-index:-1;animation:bmMiniPulse 2.2s ease-out infinite}",
      "@keyframes bmMiniPulse{0%{box-shadow:0 0 0 0 rgba(37,211,102,.5)}70%{box-shadow:0 0 0 17px rgba(37,211,102,0)}100%{box-shadow:0 0 0 0 rgba(37,211,102,0)}}",
      "#minimized-widget-icon.bm-mini:active{transform:scale(.95)}",
      "@media (hover:hover) and (pointer:fine){#minimized-widget-icon.bm-mini:hover{transform:scale(1.06)}}",
      ".bm-mini-nudge{position:fixed;right:24px;bottom:108px;z-index:10000;max-width:250px;background:#fff;color:#0f172a;border-radius:14px;box-shadow:0 12px 32px rgba(0,0,0,.22);padding:11px 13px 12px;font-family:'Inter',var(--font-body-family,sans-serif);cursor:pointer;opacity:0;transform:translateY(8px) scale(.96);transition:opacity .22s cubic-bezier(.23,1,.32,1),transform .22s cubic-bezier(.23,1,.32,1)}",
      ".bm-mini-nudge.show{opacity:1;transform:translateY(0) scale(1)}",
      ".bm-mini-nudge::after{content:'';position:absolute;right:22px;bottom:-5px;width:11px;height:11px;background:#fff;transform:rotate(45deg)}",
      ".bm-mini-nudge-name{font-size:11.5px;font-weight:600;color:#0f172a}",
      ".bm-mini-nudge-msg{font-size:11.5px;color:#475569;line-height:1.4;margin-top:2px;padding-right:10px}",
      ".bm-mini-nudge-cta{display:inline-flex;align-items:center;gap:4px;margin-top:8px;font-size:11.5px;font-weight:600;color:" + BRAND + "}",
      ".bm-mini-nudge-x{position:absolute;top:3px;right:5px;background:none;border:0;color:#94a3b8;font-size:15px;line-height:1;cursor:pointer;padding:2px 5px}",
      ".bm-mini-nudge-x:hover{color:#0f172a}",
      "@media (max-width:767px){.bm-mini-nudge{right:18px;bottom:102px;max-width:214px}}",
      "@media (prefers-reduced-motion: reduce){.cta-demo .bm-dot{animation:none}#bm-eu-panel.bm-on{animation:none}#minimized-widget-icon.bm-mini .bm-mini-pulse{animation:none}.bm-mini-nudge{transition:opacity .2s ease;transform:none}.bm-mini-nudge.show{transform:none}}"
    ].join("\n")));
    (document.head || document.documentElement).appendChild(s);
  }

  function flagEmoji(iso) {
    if (!/^[A-Z]{2}$/.test(iso)) return "";
    try { return String.fromCodePoint(0x1F1E6 + iso.charCodeAt(0) - 65, 0x1F1E6 + iso.charCodeAt(1) - 65); } catch (e) { return ""; }
  }
  function countryName(iso) {
    try { return (new Intl.DisplayNames([lang()], { type: "region" })).of(iso) || iso; } catch (e) { return iso; }
  }
  function servedCountries() {
    var list = (Array.isArray(window.SHOP_AVAILABLE_COUNTRIES) && window.SHOP_AVAILABLE_COUNTRIES.length)
      ? window.SHOP_AVAILABLE_COUNTRIES.slice() : FALLBACK_COUNTRIES.slice();
    list = list.map(function (c) { return String(c || "").toUpperCase(); }).filter(function (c) { return /^[A-Z]{2}$/.test(c) && c !== "DE"; });
    list = list.filter(function (c, i) { return list.indexOf(c) === i; });
    list.sort(function (a, b) { return countryName(a).localeCompare(countryName(b), lang()); });
    return list;
  }
  function defaultCountry(list) {
    var d = geoCountry;
    if (d && list.indexOf(d) >= 0) return d;
    d = shopifyCountry();
    if (d && list.indexOf(d) >= 0) return d;
    var lg = lang();
    if (lg === "fr" && list.indexOf("FR") >= 0) return "FR";
    if (lg === "de" && list.indexOf("AT") >= 0) return "AT";
    return list[0] || "FR";
  }

  function buildPanel() {
    if (panel) return panel;
    panel = document.createElement("div");
    panel.id = "bm-eu-panel";
    panel.setAttribute("role", "dialog");
    panel.setAttribute("aria-label", "Book a call or demo");
    panel.innerHTML =
      '<div class="bm-head">' +
        '<button type="button" class="bm-iconbtn bm-back" aria-label="Back">' + icBack() + '</button>' +
        '<img class="bm-av" alt="" width="26" height="26" style="display:none"/>' +
        '<span class="bm-title"></span>' +
        '<button type="button" class="bm-iconbtn bm-x" aria-label="Close">' + icClose() + '</button>' +
      '</div>' +
      '<div class="bm-step bm-step-country"><div class="bm-country">' +
        '<h3 class="bm-where"></h3><p class="bm-hint"></p>' +
        '<select class="bm-country-sel" aria-label="Country"></select>' +
        '<button type="button" class="bm-continue"></button>' +
      '</div></div>' +
      '<div class="bm-step bm-step-booking" style="display:none">' +
        '<div class="bm-seg" role="group"></div>' +
        '<div class="bm-cal-host"></div>' +
        '<div class="bm-foot">' + icCal() + '<span style="margin-left:2px" class="bm-foot-txt"></span></div>' +
      '</div>';
    document.body.appendChild(panel);
    panel.querySelector(".bm-back").addEventListener("click", onBack);
    panel.querySelector(".bm-x").addEventListener("click", minimizeAll);
    panel.querySelector(".bm-continue").addEventListener("click", onContinue);
    return panel;
  }

  function renderCountryLoadingStep() {
    var t = L();
    panel.querySelector(".bm-title").textContent = t.cta;
    panel.querySelector(".bm-av").style.display = "none";
    panel.querySelector(".bm-where").textContent = t.where;
    panel.querySelector(".bm-hint").textContent = t.hint;
    var sel = panel.querySelector(".bm-country-sel");
    sel.innerHTML = '<option value="">' + t.detecting + "</option>";
    sel.disabled = true;
    var cont = panel.querySelector(".bm-continue");
    cont.innerHTML = "<span>" + t.detecting + "</span>";
    cont.disabled = true;
    panel.querySelector(".bm-step-country").style.display = "flex";
    panel.querySelector(".bm-step-booking").style.display = "none";
  }

  function renderCountryStep() {
    var t = L();
    panel.querySelector(".bm-title").textContent = t.cta;
    panel.querySelector(".bm-av").style.display = "none";
    panel.querySelector(".bm-where").textContent = t.where;
    panel.querySelector(".bm-hint").textContent = t.hint;
    var sel = panel.querySelector(".bm-country-sel");
    var list = servedCountries(), def = defaultCountry(list);
    sel.innerHTML = list.map(function (c) {
      return '<option value="' + c + '"' + (c === def ? " selected" : "") + ">" + flagEmoji(c) + "  " + countryName(c) + "</option>";
    }).join("");
    sel.disabled = false;
    var cont = panel.querySelector(".bm-continue");
    cont.innerHTML = "<span>" + t.cont + "</span>" + icArrow();
    cont.disabled = false;
    panel.querySelector(".bm-step-country").style.display = "flex";
    panel.querySelector(".bm-step-booking").style.display = "none";
  }

  function renderBookingStep() {
    var t = L(), a = AGENTS[bookingAgent] || AGENTS.jordan;
    panel.querySelector(".bm-title").textContent = t.bookWith + " " + a.name;
    var av = panel.querySelector(".bm-av");
    av.src = a.img; av.alt = a.name; av.style.display = "block";
    var seg = panel.querySelector(".bm-seg");
    seg.setAttribute("aria-label", t.cta);
    seg.innerHTML =
      '<button type="button" data-ev="quick_call" aria-pressed="false"><span style="display:flex;align-items:center;gap:6px">' + icPhone() + '<span class="bm-lbl">' + t.call + '</span></span><span class="bm-sub">' + t.callSub + '</span></button>' +
      '<button type="button" data-ev="full_demo" aria-pressed="false"><span style="display:flex;align-items:center;gap:6px">' + icVideo() + '<span class="bm-lbl">' + t.demo + '</span></span><span class="bm-sub">' + t.demoSub + '</span></button>';
    seg.querySelectorAll("button").forEach(function (b) {
      b.addEventListener("click", function () { selectEvent(b.getAttribute("data-ev")); });
    });
    panel.querySelector(".bm-foot-txt").textContent = t.tz;
    panel.querySelector(".bm-step-country").style.display = "none";
    panel.querySelector(".bm-step-booking").style.display = "flex";
    selectEvent(selectedEvent);
  }

  function loadCal() {
    if (calLoaded) return;
    calLoaded = true;
    (function (C, A, L2) {
      var p = function (a, ar) { a.q.push(ar); };
      var d = C.document;
      C.Cal = C.Cal || function () {
        var cal = C.Cal, ar = arguments;
        if (!cal.loaded) { cal.ns = {}; cal.q = cal.q || []; d.head.appendChild(d.createElement("script")).src = A; cal.loaded = true; }
        if (ar[0] === L2) {
          var api = function () { p(api, arguments); };
          var ns = ar[1]; api.q = api.q || [];
          if (typeof ns === "string") { cal.ns[ns] = cal.ns[ns] || api; p(cal.ns[ns], ar); p(cal, ["initNamespace", ns]); }
          else p(cal, ar);
          return;
        }
        p(cal, ar);
      };
    })(window, CAL_ORIGIN + "/embed/embed.js", "init");
    window.Cal("init", { origin: CAL_ORIGIN });
    window.Cal("ui", { theme: "light", styles: { branding: { brandColor: BRAND } }, cssVarsPerTheme: { light: { "cal-brand": BRAND } }, hideEventTypeDetails: false, layout: "month_view" });
    try { window.Cal("on", { action: "bookingSuccessful", callback: function () { track("booking_success_" + bookingAgent); } }); } catch (e) {}
  }

  function renderEmbed() {
    var a = AGENTS[bookingAgent] || AGENTS.jordan;
    var calLink = a.cal + "/" + (selectedEvent === "quick_call" ? "quick-qa" : "full-demo");
    var host = panel.querySelector(".bm-cal-host");
    host.innerHTML = '<div class="bm-loading">' + L().loading + '</div><div id="bm-eu-cal"></div>';
    if (embedFailTimer) { clearTimeout(embedFailTimer); embedFailTimer = null; }
    function fallback() {
      var h = panel && panel.querySelector(".bm-cal-host");
      if (h) h.innerHTML = '<div class="bm-loading"><a href="' + CAL_ORIGIN + "/" + calLink + '" target="_blank" rel="noopener" style="color:' + BRAND + ';font-weight:600">' + L().openPage + '</a></div>';
    }
    try {
      window.Cal("inline", { elementOrSelector: "#bm-eu-cal", calLink: calLink, config: { layout: "month_view", theme: "light" } });
    } catch (e) { fallback(); return; }
    lastRendered = bookingAgent + "|" + selectedEvent;
    // If embed.js is blocked (CSP / ad-blocker / offline) no iframe ever mounts —
    // swap the spinner for a direct booking link instead of spinning forever.
    embedFailTimer = setTimeout(function () {
      var el = panel && panel.querySelector("#bm-eu-cal");
      if (el && !el.querySelector("iframe")) fallback();
    }, 6000);
  }

  function selectEvent(key) {
    if (key !== "quick_call" && key !== "full_demo") key = "quick_call";
    selectedEvent = key;
    panel.querySelectorAll(".bm-seg button").forEach(function (b) {
      b.setAttribute("aria-pressed", b.getAttribute("data-ev") === key ? "true" : "false");
    });
    // skip a redundant re-render only when the SAME agent+event is already mounted
    if (lastRendered === bookingAgent + "|" + key && panel.querySelector("#bm-eu-cal iframe")) return;
    loadCal();
    renderEmbed();
    track("book_" + key + "_" + bookingAgent);
  }

  function onContinue() {
    var sel = panel.querySelector(".bm-country-sel");
    var country = sel ? sel.value : detectedCountry();
    bookingAgent = routeAgent(country, rawLang());
    track("country_" + country + "_" + bookingAgent);
    renderBookingStep();
  }

  function openBooking() {
    injectStyles();
    buildPanel();
    if (widget) widget.style.display = "none";
    var mini = document.getElementById("minimized-widget-icon");
    if (mini) mini.style.display = "none";
    panel.classList.add("bm-on");
    if (geoCountryDone) {
      renderCountryStep();
    } else {
      renderCountryLoadingStep();
      fetchGeoCountry().then(function () {
        if (panel && panel.classList.contains("bm-on") && panel.querySelector(".bm-step-country").style.display !== "none") {
          renderCountryStep();
        }
      });
    }
    track("book_open");
  }

  function showOptions() {
    if (panel) panel.classList.remove("bm-on");
    if (widget) { widget.style.display = "block"; var cb = document.getElementById("chat-box"); if (cb && !isMobile()) cb.style.display = "block"; }
  }
  function onBack() {
    // from booking step -> back to country step; from country step -> back to chat options
    if (panel && panel.querySelector(".bm-step-booking").style.display !== "none") { renderCountryStep(); return; }
    showOptions();
  }
  function minimizeAll() {
    if (panel) panel.classList.remove("bm-on");
    try { sessionStorage.setItem("euChatWidgetMinimized", "1"); } catch (e) {}
    if (widget) widget.style.display = "none";
    var mini = document.getElementById("minimized-widget-icon");
    if (mini) mini.style.display = "block";
  }
  function isMobile() { try { return window.matchMedia("(max-width: 767px)").matches; } catch (e) { return false; } }

  function escapeHtml(s) { return String(s).replace(/[&<>"]/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]; }); }

  function applyCta() {
    var demo = widget && widget.querySelector(".cta-demo");
    if (!demo) return;
    var main = demo.querySelector(".bm-demo-main");
    if (!main) { main = document.createElement("span"); main.className = "bm-demo-main"; demo.textContent = ""; demo.appendChild(main); }
    main.innerHTML = icCal() + "<span>" + escapeHtml(L().cta) + "</span>";
    var teaser = demo.querySelector(".bm-demo-teaser");
    if (!teaser) { teaser = document.createElement("span"); teaser.className = "bm-demo-teaser"; teaser.style.display = "none"; demo.appendChild(teaser); }
    fetchTeaser(teaser, displayedAgentKey());
  }

  function fetchTeaser(teaser, agent) {
    var tz = visitorTz();
    var ctrl = ("AbortController" in window) ? new AbortController() : null;
    var to = setTimeout(function () { if (ctrl) { try { ctrl.abort(); } catch (e) {} } }, 2500);
    // Race against a timeout so the teaser can never stall even where
    // AbortController is unavailable (old Safari / some WebViews).
    var req = fetch(NEXT_SLOT_URL + "?agent=" + encodeURIComponent(agent) + "&event=soonest&tz=" + encodeURIComponent(tz), ctrl ? { signal: ctrl.signal } : undefined)
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
    var timeout = new Promise(function (resolve) { setTimeout(function () { resolve(null); }, 2500); });
    Promise.race([req, timeout]).then(function (j) {
      clearTimeout(to);
      if (!j || !j.time) { teaser.style.display = "none"; return; } // additive: stay hidden
      teaser.innerHTML = '<span class="bm-dot"></span><span>' + escapeHtml(L().next) + ' <b>' + escapeHtml(teaserLabel(j.time, tz)) + "</b></span>";
      teaser.style.display = "flex";
    });
  }

  function wireCta() {
    var demo = widget && widget.querySelector(".cta-demo");
    if (!demo) return false;
    if (!demo.__bmEuWired) {
      demo.__bmEuWired = true;
      demo.addEventListener("click", function (e) { e.preventDefault(); openBooking(); });
    }
    applyCta();
    return true;
  }

  function relocalize() {
    // After the EU widget's updateLanguage() re-renders the CTA, re-apply our
    // label + teaser, and refresh any open panel in the new language.
    setTimeout(function () {
      applyCta();
      enhanceMiniIcon(); // keep the minimized launcher's face in sync with the agent
      if (panel && panel.classList.contains("bm-on")) {
        if (panel.querySelector(".bm-step-booking").style.display !== "none") renderBookingStep();
        else renderCountryStep();
      }
    }, 0);
  }

  // ── Minimized launcher: routed-agent face + live "online" dot + soft pulse,
  //    plus a once-per-session localized re-engagement nudge → opens booking.
  function miniAvatar() { var a = AGENTS[displayedAgentKey()] || AGENTS.jordan; return a.img; }
  function waSvg() { return '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M.057 24l1.687-6.163c-1.041-1.804-1.588-3.849-1.587-5.946.003-6.556 5.338-11.891 11.893-11.891 3.181.001 6.167 1.24 8.413 3.488 2.245 2.248 3.481 5.236 3.48 8.414-.003 6.557-5.338 11.892-11.893 11.892-1.99-.001-3.951-.5-5.688-1.448l-6.305 1.654zm6.597-3.807c1.676.995 3.276 1.591 5.392 1.592 5.448 0 9.886-4.434 9.889-9.885.002-5.462-4.415-9.89-9.881-9.892-5.452 0-9.887 4.434-9.889 9.884-.001 2.225.651 3.891 1.746 5.634l-.999 3.648 3.742-.981zm11.387-5.464c-.074-.124-.272-.198-.57-.347-.297-.149-1.758-.868-2.031-.967-.272-.099-.47-.149-.669.149-.198.297-.768.967-.941 1.165-.173.198-.347.223-.644.074-.297-.149-1.255-.462-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.521.151-.172.2-.296.3-.495.099-.198.05-.372-.025-.521-.075-.148-.669-1.611-.916-2.206-.242-.579-.487-.501-.669-.51l-.57-.01c-.198 0-.52.074-.792.372s-1.04 1.016-1.04 2.479 1.065 2.876 1.213 3.074c.149.198 2.095 3.2 5.076 4.487.709.306 1.263.489 1.694.626.712.226 1.36.194 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.695.248-1.29.173-1.414z"/></svg>'; }
  function enhanceMiniIcon() {
    var mini = document.getElementById("minimized-widget-icon");
    if (!mini) return;
    if (!mini.__bmMini) {
      mini.__bmMini = true;
      mini.classList.add("bm-mini");
      mini.innerHTML = '<span class="bm-mini-pulse" aria-hidden="true"></span><img class="bm-mini-av" alt=""/><span class="bm-mini-wa" aria-hidden="true">' + waSvg() + '</span>';
    }
    var a = AGENTS[displayedAgentKey()] || AGENTS.jordan;
    mini.setAttribute("aria-label", "Message " + a.name + " on WhatsApp");
    var im = mini.querySelector(".bm-mini-av");
    if (im) im.src = a.img;
  }
  function observeMini() {
    var mini = document.getElementById("minimized-widget-icon");
    if (!mini || mini.__bmMiniObs) return;
    mini.__bmMiniObs = true;
    var obs = new MutationObserver(function () {
      if (mini.style.display !== "none") maybeShowMiniNudge();  // fixed-pos: offsetParent is always null, use display
      else hideMiniNudge();
    });
    obs.observe(mini, { attributes: true, attributeFilter: ["style"] });
    if (mini.style.display === "block") maybeShowMiniNudge();
  }
  function maybeShowMiniNudge() {
    if (miniNudgeEl || miniNudgePending) return;
    try { if (sessionStorage.getItem("bmMiniNudgeSeen") === "1") return; } catch (e) {}
    miniNudgePending = true;
    setTimeout(function () {
      miniNudgePending = false;
      var mini = document.getElementById("minimized-widget-icon");
      if (!mini || mini.style.display === "none") return;
      try { sessionStorage.setItem("bmMiniNudgeSeen", "1"); } catch (e) {}
      buildMiniNudge();
    }, 1800);
  }
  function buildMiniNudge() {
    if (miniNudgeEl) return;
    var a = AGENTS[displayedAgentKey()] || AGENTS.jordan;
    var name = (HI[rawLang()] || HI.en) + a.name + " 👋";
    miniNudgeEl = document.createElement("div");
    miniNudgeEl.className = "bm-mini-nudge";
    miniNudgeEl.setAttribute("role", "button");
    miniNudgeEl.setAttribute("tabindex", "0");
    miniNudgeEl.innerHTML =
      '<button class="bm-mini-nudge-x" type="button" aria-label="Dismiss">×</button>' +
      '<div class="bm-mini-nudge-name">' + escapeHtml(name) + '</div>' +
      '<div class="bm-mini-nudge-msg">' + escapeHtml(L().miniMsg) + '</div>' +
      '<div class="bm-mini-nudge-cta">' + escapeHtml(L().miniCta) + '</div>';
    document.body.appendChild(miniNudgeEl);
    miniNudgeEl.querySelector(".bm-mini-nudge-x").addEventListener("click", function (e) { e.stopPropagation(); dismissMiniNudge(); });
    miniNudgeEl.addEventListener("click", function () { dismissMiniNudge(); openBooking(); });
    requestAnimationFrame(function () { setTimeout(function () { if (miniNudgeEl) miniNudgeEl.classList.add("show"); }, 20); });
  }
  function hideMiniNudge() {
    if (!miniNudgeEl) return;
    var el = miniNudgeEl; miniNudgeEl = null;
    el.classList.remove("show");
    setTimeout(function () { if (el.parentNode) el.parentNode.removeChild(el); }, 240);
  }
  function dismissMiniNudge() { try { sessionStorage.setItem("bmMiniNudgeSeen", "1"); } catch (e) {} hideMiniNudge(); }
  function setupMini() { enhanceMiniIcon(); observeMini(); }

  function start() {
    widget = document.getElementById("custom-chat-widget");
    injectStyles();
    fetchGeoCountry().then(function () { if (widget) applyCta(); });
    var ok = widget && wireCta();
    setupMini();
    var sel = document.getElementById("language-switch");
    if (sel && !sel.__bmEuLang) { sel.__bmEuLang = true; sel.addEventListener("change", relocalize); }
    if (ok) return;
    var n = 0;
    var iv = setInterval(function () {
      widget = document.getElementById("custom-chat-widget");
      n += 1;
      if ((widget && wireCta()) || n > 60) {
        var sl = document.getElementById("language-switch");
        if (sl && !sl.__bmEuLang) { sl.__bmEuLang = true; sl.addEventListener("change", relocalize); }
        clearInterval(iv);
      }
    }, 100);
  }

  window.bmBookingEU = {
    open: openBooking,
    route: function () { return routeAgent(detectedCountry(), rawLang()); },
    relocalize: relocalize,
  };

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start);
  else start();
})();
